import dayjs from "dayjs";
import apiUser from "@/api/user.js";

const state = {
  signedIn: false,
  organized: false,
  signInMethod: "organizational",

  username: "Unknown",
  userTotalPoints: 0,
  userUsedPoints: 0,
  expiryTime: new Date(),
  profileImageSource: "",

  organizationName: "Unknown",
  organizationalTotalPoints: 0,
  organizationalUsedPoints: 0,

  specialOrganizationNameList: [],
};

const mutations = {
  setSignedIn(state, signedIn) {
    state.signedIn = signedIn;
  },
  setOrganized(state, organized) {
    state.organized = organized;
  },
  setSignedInMethod(state, signInMethod) {
    const signInMethodList = ["individual", "organizational"];
    signInMethod = signInMethodList.includes(signInMethod)
      ? signInMethod
      : "organizational";
    state.signInMethod = signInMethod;
    localStorage.setItem("user/signInMethod", `${signInMethod}`);
  },

  setUsername(state, username) {
    state.username = username || "Unknown";
  },
  setUserTotalPoints(state, userTotalPoints) {
    state.userTotalPoints = userTotalPoints;
  },
  setUserUsedPoints(state, userUsedPoints) {
    state.userUsedPoints = userUsedPoints;
  },
  setExpiryTime(state, expiryTime) {
    state.expiryTime = expiryTime;
  },
  setProfileImageSource(state, profileImageSource) {
    state.profileImageSource = profileImageSource.startsWith("http")
      ? profileImageSource
      : profileImageSource
      ? `${location.origin}/${profileImageSource}`
      : "";
  },

  setOrganizationName(state, organizationName) {
    state.organizationName = organizationName || "Unknown";
  },
  setOrganizationalTotalPoints(state, organizationalTotalPoints) {
    state.organizationalTotalPoints = organizationalTotalPoints;
  },
  setOrganizationalUsedPoints(state, organizationalUsedPoints) {
    state.organizationalUsedPoints = organizationalUsedPoints;
  },
  setSpecialOrganizationNameList(state, specialOrganizationNameList) {
    state.specialOrganizationNameList = specialOrganizationNameList;
  },
};

const actions = {
  // 获取用户登录信息接口操作
  async handleFetchUserInfo({ commit }) {
    const {
      data: {
        isBranchLogin: organized,
        isUserLogin: signedIn,
        userInfo,
        branchInfo: organizationInfo,
      },
    } = await apiUser.fetchUserInfo().catch((error) => {
      console.error("handleFetchUserInfo");
      throw error;
    });
    commit("setSignedIn", signedIn);
    commit("setOrganized", organized);
    if (!signedIn) {
      return;
    }
    const {
      RealName: realName,
      UserName: username,
      TotalPoints: userTotalPoints,
      UsedPoints: userUsedPoints,
      ExpiryTime: expiryTime,
      LogoFile: profileImageSource,
    } = userInfo || {};
    commit("setUsername", realName || username);
    commit("setUserTotalPoints", userTotalPoints);
    commit("setUserUsedPoints", userUsedPoints);
    commit(
      "setExpiryTime",
      expiryTime
        ? parseInt(expiryTime)
        : dayjs().add(1, "year").startOf("day").valueOf()
    );
    commit("setProfileImageSource", profileImageSource);
    if (!organized) {
      return;
    }
    const {
      BranchName: organizationName,
      TotalPoints: organizationalTotalPoints,
      UsedPoints: organizationalUsedPoints,
    } = organizationInfo || {};
    const signInMethod = localStorage.getItem("user/signInMethod");
    commit("setSignedInMethod", signInMethod);
    commit("setOrganizationName", organizationName);
    commit("setOrganizationalTotalPoints", organizationalTotalPoints);
    commit("setOrganizationalUsedPoints", organizationalUsedPoints);
  },
  // 退出登录接口操作
  async handleSignOut() {
    const { logout } = await apiUser.signOut().catch((error) => {
      console.error("handleSignOut");
      throw error;
    });
    location.href = logout;
  },
  // 获取特殊机构名称列表接口操作
  async handleSpecialOrganizationNameList({ commit }) {
    const data = await apiUser
      .fetchSpecialOrganizationNameList()
      .catch((error) => {
        console.error("handleSpecialOrganizationNameList");
        throw error;
      });
    const specialOrganizationNameList = Array.isArray(data) ? data : [];
    commit("setSpecialOrganizationNameList", specialOrganizationNameList);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
